export default function PHP_rand() {
  return (
    <div>
      <h1>PHP_rand</h1>
    </div>
  );
}
